<template>
  <Modal class="max-w-[440px]!">
    <h2 class="pr-6 text-[26px] leading-[30px] font-medium text-gray-800">
      Proof of infringement report with
      <DacrAIIcon
        class="inline-block h-[22px] w-auto align-[-2px]"
        aria-label="Dacr AI"
      />
    </h2>

    <p class="mt-4 text-[15px] leading-[22px] text-gray-500">
      DIIS powered by Dacr AI identifies every point of similarity between your
      work and the suspected infringement. Court-admissible evidence.
    </p>

    <a
      href="/diis"
      target="_blank"
      class="text-link mt-1.5 inline-block text-[15px] leading-[22px]"
    >
      Learn more
    </a>

    <div class="-mx-6 mt-6 overflow-hidden">
      <img
        :src="InfringementImage"
        class="relative left-1/2 w-[130%] max-w-none -translate-x-1/2"
        alt=""
      />
    </div>

    <div class="mt-6 flex items-end justify-between gap-x-4">
      <div>
        <div class="text-[14px] leading-[18px] font-medium text-gray-400">
          Comparison analysis report
        </div>
        <div
          class="mt-0.5 text-[34px] leading-[38px] font-medium text-gray-800"
        >
          {{ reportPrice }}
        </div>
      </div>
      <Button variant="primary" size="md" @click="handleGetReport">
        Get report
      </Button>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'
import { DacrAIIcon } from '@dacr/icons'

import InfringementImage from '@/assets/images/Infringement.png'
import { useInfringementReport } from '../useInfringementReport'
import { formatPrice } from '@/shared/utils/money'
import { computed } from 'vue'

const { handleGetReport } = useInfringementReport()
const reportPrice = computed(() =>
  formatPrice({ amount: 20, hideDecimals: true })
)
</script>
